export const RELATION = {
  PASTURE: 'pasture'
};

export const RELATION_SUBTYPE = {
  LIVESTOCK: 'livestock',
  BREEDING: 'breeding',
  MEASURE: 'measure',
  TREATMENT: 'treatment',
  ROTATION: 'rotation'
};

export const RELATION_TYPES = [
  'pasture',
  'livestock',
  'farm',
  'site',
  'group'
  // 'tag',
  // 'gateway',
];

export const RECURRING_TYPES = ['day', 'week', 'month', 'year', 'custom'];

export const CUSTOM_RECURRING_UNITS = ['days', 'weeks', 'months', 'years'];

export const EVENT_MODAL_MODE = {
  CREATE: 'create',
  UPDATE: 'update',
  VIEW: 'view',
  GUEST: 'guest'
};

export const INVITE_STATUS = {
  ACCEPTED: 'accepted',
  DECLINED: 'declined'
};

export const MIN_EVENT_DURATION = {
  VALUE: 1,
  UNIT: 'minutes'
};

export const DEFAULT_EVENT_DURATION = {
  VALUE: 30,
  UNIT: 'minutes'
};

export const MINUTE_STEP = 15;
